module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("Contents")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thedragonscat"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Dragon’s Cat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Jody Lynn Nye")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/soburnusboth"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("So Burn Us Both")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Lisse Kirk")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/trialbycow"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Trial by Cow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Andrew Rucker Jones")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/blackwoodstomb"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Blackwood’s Tomb")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Joseph Floyd")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/theritualistandthehedgewizard"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Ritualist and the Hedge-Wizard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kit Calvert")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/beneaththewingsofnight"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Beneath the Wings of Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Ngo Binh Anh Khoa")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/kittenforsale"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Kitten for Sale")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Aster Marsh")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thedreamer"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Dreamer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("M. Lalli Lassegard")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/aratarootandabigorangefruit"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Rat, a Root, and a Big Orange Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Zach Shephard")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/secondlife"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Second Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Christina Sng")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thewitchinghourletters"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Witching Hour Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Amanda Cecelia Lang & Brittany Noelle")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thefamiliarsfamiliar"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Familiar’s Familiar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Maegan Langer")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thecat"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Cat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Sandy White")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/somespider"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Some Spider")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Pines Callahan")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/scaryscaryskunk"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Scary, Scary, Skunk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Heather Graham")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/orphans",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Orphans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Matt Beswick")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thelastlifeofhildethesmall"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Last Life of Hilde the Small")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Jessica Feather")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/andhaveneverforgotten"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("“And Have Never Forgotten”*")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Mercedes Lackey")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/fluffy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Fluffy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("T. Chandler")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/earthbonding"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Earth, Bonding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kerri J. Roe")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/notcommonafibonaccipoem"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Not Common: A Fibonacci Poem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Lois T. Bartholomew")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thesecretofthesorceress"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Secret of the Sorceress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Alexander Hay")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/sinkorswim"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sink or Swim")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Rebecca M. Senese")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/oldcrow"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Old Crow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Steve Rasnic Tem")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/tailend"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Tail-End")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Lia Wu")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/nameless",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Nameless")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("John G. Hartness")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheexecutiveeditors"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("About the Executive Editors")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouenjoyedfeistyfelines"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("If You Enjoyed Feisty Felines")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/copyrightinformation"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Copyright Information")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0